// removed by extract-text-webpack-plugin
module.exports = {"logo":"_23G0l8x"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Header/Logo/index.css
// module id = ./template/components/Header/Logo/index.css
// module chunks = client.sitechrome